import React from "react";
import av1 from "./av1.jpg";
import av2 from "./av2.jpg";
import av3 from "./av3.jpg";
import "./chef.css";
import Aos from "aos";
import "aos/dist/aos.css";
function Chef() {
  React.useEffect(() => {
    Aos.init();
  }, []);

  return (
    <>
      <section class="team-section">
        <div class="container2">
          <div className="temoignage-head">
            <span> 09 50 85 13 53</span>
            <h1> Notre Equipe 💡 </h1>
          </div>

          <div class="row2" data-aos="fade-up" data-aos-duration="1500">
            <div class="team-items">
              <div class="item">
                <img
                  src="https://mvistatic.com/photosmvi/2020/11/02/P23996371D4313081G.jpg"
                  alt="team"
                />
                <div class="inner">
                  <div class="info">
                    <h5>Mohamed hitana</h5>
                    <p>Propriétere</p>
                    <div class="social-links">
                      <a href="">
                        <span class="fa fa-facebook"></span>
                      </a>
                      <a href="">
                        <span class="fa fa-twitter"></span>
                      </a>
                      <a href="">
                        <span class="fa fa-linkedin"></span>
                      </a>
                      <a href="">
                        <span class="fa fa-youtube"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="item">
                <img
                  src="https://food.konbini.com/files/2018/10/chef-tchane-1000.jpg"
                  alt="team"
                />
                <div class="inner">
                  <div class="info">
                    <h5>Mohamed biggy</h5>
                    <p>Associé / Caissier</p>
                    <div class="social-links">
                      <a href="">
                        <span class="fa fa-facebook"></span>
                      </a>
                      <a href="">
                        <span class="fa fa-twitter"></span>
                      </a>
                      <a href="">
                        <span class="fa fa-linkedin"></span>
                      </a>
                      <a href="">
                        <span class="fa fa-youtube"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="item">
                <img
                  src="https://previews.123rf.com/images/jackf/jackf1610/jackf161000644/63439904-homme-d-%C3%A2ge-m%C3%BBr-souriant-chef-portant-l-uniforme-pr%C3%A9parant-kebab-tenant-le-pouce-en-l-air-sur-la-cu.jpg"
                  alt="team"
                />
                <div class="inner">
                  <div class="info">
                    <h5>Hamadi</h5>
                    <p>Cuisinier</p>
                    <div class="social-links">
                      <a href="">
                        <span class="fa fa-facebook"></span>
                      </a>
                      <a href="">
                        <span class="fa fa-twitter"></span>
                      </a>
                      <a href="">
                        <span class="fa fa-linkedin"></span>
                      </a>
                      <a href="">
                        <span class="fa fa-youtube"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Chef;
